import React from 'react';
import { Button } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';

const CancelContractButton: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const company = searchParams.get('company') || '';

  const handleCancel = () => {
    navigate(`/contracts?company=${encodeURIComponent(company)}`);
  };

  return (
    <Button
      variant="outlined"
      startIcon={<BackIcon />}
      onClick={handleCancel}
      sx={{ minWidth: 120 }}
    >
      Back
    </Button>
  );
};

export default CancelContractButton;
